import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from '@aws-amplify/auth';

@Component({
  selector: 'app-signout',
  templateUrl: './signout.component.html',
  styleUrls: ['./signout.component.css'],
  standalone: false
})
export class SignoutComponent implements OnInit {
  constructor(private router: Router) {}

  public ngOnInit(): void {
    Auth.signOut({ global: true });
  }

  public login() {
    this.router.navigate(['/login']);
  }
}
